import { render, staticRenderFns } from "./Prenatal.vue?vue&type=template&id=6b83adf5&scoped=true"
import script from "./Prenatal.vue?vue&type=script&lang=js"
export * from "./Prenatal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83adf5",
  null
  
)

export default component.exports